import React, { useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { M_StateActions, M_Table, LoadingContext, BufferService } from 'src/components/M_Components'

export const UserConfig = ({ roles, onCreateTab, toastMessages }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [isLabel, setIsLabel] = useState(true)
    const [refresh, setRefresh] = useState(false)
    const ctx = useContext(LoadingContext)
    const bufferServiceUser = new BufferService('identity')
    const removeContextItems = ['Print', 'Copy', 'View']

    const NewRoute = (url, label, operation, data) => {
        dispatch(M_StateActions.addM_State({ key: 'operation', value: operation }))
        if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            if (!data) {
                toastMessages('error', '', t("SelectedLine"))
                return
            }
            dispatch(M_StateActions.addM_State({ key: 'UserLine', value: data }))
        }
        if (operation === 'Create') {
            onCreateTab(url, label)
        }
        else if (operation === 'Edit' || operation === 'Copy' || operation === 'View') {
            onCreateTab(url, `${label} "${data.UserName}"`)
        }
    }

    const onHide = (e) => {
        setIsLabel(e)
    }

    const deleteUser = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            tempData.forEach(obj => {
                deleteFunc(obj.Id)
            })
            return
        }
        deleteFunc(tempData.Id)
    }

    function deleteFunc(id) {
        bufferServiceUser.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorDeleteUser"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessDeleteUser"))
            setRefresh(true)
        })
    }

    return (
        <div className='divGlobalSettings'>
            <div className='subTitleSettings'>
                <div>
                    <div style={{ color: ctx.secondaryColor }}>
                        {t("Users")}
                    </div>
                    <div className='labelSubtitleSettings'>
                        {t("InfoUsers")}
                    </div>
                </div>
            </div>
            <M_Table
                filtersOnTable
                entityName={'listUsers'}
                roleName={'user config'}
                rolePermissions={roles}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                refresh={refresh}
                setRefresh={setRefresh}
                useSessionStorage={false}
                replaceFunctions={new Map([
                    // ['View', (e) => NewRoute("UserConfig", t("LabelViewUser"), 'View', e)],
                    ['Create', (e) => NewRoute("UserConfigCrud", t("LabelNewUser"), 'Create', e)],
                    ['Edit', (e) => NewRoute("UserConfigCrud", t("LabelEditUser"), 'Edit', e)],
                    ['Delete', (e) => deleteUser(e)]
                ])}
            />
        </div>
    )
}